/** Dados de execução “fixados” no editor (localStorage), estilo pin do n8n. */

const STORAGE_PREFIX = 'chatwoot:workflow-editor-pinned-exec:v1:';

export function pinnedExecutionStorageKey(accountId, workflowId) {
  return `${STORAGE_PREFIX}${accountId}:${workflowId}`;
}

export function readPinnedExecution(accountId, workflowId) {
  if (accountId == null || workflowId == null) return null;
  try {
    const raw = localStorage.getItem(
      pinnedExecutionStorageKey(accountId, workflowId)
    );
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    return data;
  } catch {
    return null;
  }
}

export function writePinnedExecution(accountId, workflowId, payload) {
  if (accountId == null || workflowId == null) return;
  localStorage.setItem(
    pinnedExecutionStorageKey(accountId, workflowId),
    JSON.stringify(payload)
  );
}

export function clearPinnedExecution(accountId, workflowId) {
  if (accountId == null || workflowId == null) return;
  localStorage.removeItem(pinnedExecutionStorageKey(accountId, workflowId));
}

/** Último snapshot de bindings nos passos da execução (contexto visto pelo último nó de ação). */
export function lastBindingsFromExecutionTrace(trace) {
  if (!Array.isArray(trace)) return {};
  for (let i = trace.length - 1; i >= 0; i -= 1) {
    const b = trace[i]?.input?.bindings;
    if (
      b &&
      typeof b === 'object' &&
      !Array.isArray(b) &&
      Object.keys(b).length > 0
    ) {
      try {
        return JSON.parse(JSON.stringify(b));
      } catch {
        return { ...b };
      }
    }
  }
  return {};
}

/** Resolve `{{a.b.c}}` contra o objeto de bindings. */
export function resolveWorkflowToken(bindings, token) {
  if (!bindings || token == null || token === '') return null;
  const m = String(token).match(/^\{\{([^}]+)\}\}$/);
  if (!m) return null;
  const path = m[1]
    .trim()
    .split('.')
    .map(s => s.trim())
    .filter(Boolean);
  let cur = bindings;
  for (const p of path) {
    if (cur == null || typeof cur !== 'object') return null;
    cur = cur[p];
  }
  if (cur === undefined) return null;
  return cur;
}

export function formatPinnedSampleValue(value, maxLen = 280) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  if (typeof value === 'string') {
    const s = value;
    return s.length > maxLen ? `${s.slice(0, maxLen)}…` : s;
  }
  try {
    const s = JSON.stringify(value);
    return s.length > maxLen ? `${s.slice(0, maxLen)}…` : s;
  } catch {
    return String(value);
  }
}
